var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTrustpilot = function SvgTrustpilot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.641 6.539H9.615L7.821.769 5.897 6.54H0L4.744 10l-1.795 5.77 4.872-3.59 4.743 3.59L10.77 10l4.872-3.461Z",
    fill: "#555249"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.153 11.284 10.768 10l-2.948 2.18 3.333-.897Z",
    fill: "#fff"
  })));
};

export { SvgTrustpilot as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjY0MSA2LjUzODUySDkuNjE1MzlMNy44MjA1MSAwLjc2OTI4N0w1Ljg5NzQ0IDYuNTM4NTJIMEw0Ljc0MzU5IDEwLjAwMDFMMi45NDg3MiAxNS43NjkzTDcuODIwNTEgMTIuMTc5NUwxMi41NjQxIDE1Ljc2OTNMMTAuNzY5MiAxMC4wMDAxTDE1LjY0MSA2LjUzODUyWiIgZmlsbD0iIzU1NTI0OSIvPgo8cGF0aCBkPSJNMTEuMTUzMiAxMS4yODM1TDEwLjc2ODUgMTAuMDAxNUw3LjgxOTgyIDEyLjE4MUwxMS4xNTMyIDExLjI4MzVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";